import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";

export const ChecklistItem = styled.div`
  align-items: center;
  background: ${colors.white};
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  min-height: 2.3rem;
`;
